import createChildWindow from "@core-ui/ChildWindow/createChildWindow";
import type GithubSourceAPI from "@ext/git/actions/Source/GitHub/logic/GithubSourceAPI";
import type GithubInstallation from "@ext/git/actions/Source/GitHub/model/GithubInstallation";
import { useRef, useState } from "react";

export type GithubInstallationOption = GithubInstallation & {
	label: string;
	value: string;
};

const useGithubInstallations = (sourceApi: GithubSourceAPI, isRelease: boolean) => {
	const [options, setOptions] = useState<GithubInstallationOption[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const isLoaded = useRef(false);
	// GitHub redirects after an installation to the app's fixed Setup URL, never to the desktop callback
	// server, so on desktop the child-window callback does not fire and the list is reloaded on open instead.
	const isAddingAccount = useRef(false);

	const loadInstallations = () => {
		setIsLoading(true);
		void sourceApi.getInstallations().then((installations) => {
			setOptions(
				installations.map((installation) => ({
					value: installation.name,
					label: installation.name,
					...installation,
				})),
			);
			setIsLoading(false);
		});
	};

	const addAccount = () => {
		isAddingAccount.current = true;
		void createChildWindow(
			isRelease
				? "https://github.com/apps/gram-ax/installations/select_target"
				: "https://github.com/apps/gramax-dev/installations/select_target",
			700,
			550,
			"https://github.com/login/device/success",
			loadInstallations,
		);
	};

	const onOpenChange = (open: boolean) => {
		if (!open || (isLoaded.current && !isAddingAccount.current)) return;
		isLoaded.current = true;
		loadInstallations();
	};

	return { options, isLoading, onOpenChange, addAccount };
};

export default useGithubInstallations;
